// Refresh map art/fronts and physics together after an office edit (or its private local preview).
import { ZoneLabels } from './entities.js';
import { portalLabels } from './labels.js';
import { localizePlaces } from './places.js';
export function refreshMap(scene, map) {
  localizePlaces(map); // the rooms an edit made: their names in the reader's language
  if (!scene) return;
  scene.deckMap.refresh();
  // (the open sea round the map follows the view, deck/tilemap.js createOcean: nothing to do when the map grows)
  scene.seatsView.seats = map.seats;
  const signature=JSON.stringify(map.zones);
  if(scene.mapZonesSignature!==signature){scene.mapZonesSignature=signature;scene.zones.layer.destroy();scene.zones=new ZoneLabels(scene,[...map.zones,...portalLabels(map.portals)]);if(window.__deck)window.__deck.labels=scene.zones.drawn;}
}
